<template>
  <div class="container-z">
    <div class="z1">
      <headimage
        :header="'Zone 1'"
        :srcimg="require('@/assets/images/background/b1.png')"
      />
    </div>
    <div class="z2">
      <headimage
        :header="'Zone 2'"
        :srcimg="require('@/assets/images/background/b2.png')"
      />
    </div>
    <div class="z1_1 card-color p-3">
      <Coundp header="People Counting" :sliderValue="12" :type="temp" />
    </div>
    <div class="z2_2 card-color p-3">
      <Coundp header="People Counting" :sliderValue="7" :type="temp" />
    </div>
    <div class="z3_3 card-color p-3">
      <Chart2 header="People Counting" :type="temp" />
    </div>
    <div class="z4_4 card-color p-3">
      <Chart2 header="People Counting" :type="temp" />
    </div>
  </div>
</template>

<script>
import headimage from "./components/peopleCounting/img_h.vue";
import Chart2 from "./components/peopleCounting/divchart.vue";
import Coundp from "./components/peopleCounting/counting.vue";
export default {
  components: { headimage, Chart2, Coundp },
  data() {
    return {
      temp: {
        value: [22, 33, 55, 50, 90, 99, 90, 70],
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "June", "july", "Aug"],
        tooltip_label: "Temperature ( °C )",
      },
      hum: { value: [], labels: [], tooltip_label: "Humidity ( % )" },
      heightofchart: 300,
    };
  },
};
</script>

<style scoped>
.container-z {
  display: grid;
  width: 100%;
  grid-template-columns: 50% 50%;
  grid-template-rows: 0.5fr 0.7fr 1fr;
  gap: 20px 20px;
  grid-auto-flow: row;
  grid-template-areas:
    "z1 z2"
    "z1_1 z2_2"
    "z3_3 z4_4";
}
.card-color {
  background-color: var(--background-color);
  border-radius: 28px;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.z1 {
  grid-area: z1;
}

.z2 {
  grid-area: z2;
}

.z1_1 {
  grid-area: z1_1;
}

.z2_2 {
  grid-area: z2_2;
}

.z3_3 {
  grid-area: z3_3;
}

.z4_4 {
  grid-area: z4_4;
}
@media only screen and (max-width: 700px) {
  .container-z {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto auto auto auto auto;
    gap: 15px 15px;
    grid-auto-flow: column;
    grid-template-areas:
      "z1"
      "z1_1"
      "z3_3"
      "z2"
      "z2_2"
      "z4_4";
  }
}
</style>